import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

interface UploadJobsReader {

  // id do intervalo
  intervalId: NodeJS.Timeout;

  // subject para emitir as atualizações do job a cada minuto
  subject: Subject<UploadJob[]>;

  // valores que representam um estado ativo do job
  activeStatus: string[];

  isActive: (job: UploadJob) => boolean;

  idAndStatus: (job: UploadJob) => IdAndStatus;

  // cancela um job em andamento
  cancel(job: UploadJob): void;

  // busca jobs. Se houver jobs ativos, continua buscando a cada minuto, enquanto houver jobs ativos
  constantFetch(): void;

  getAllJobs(): Observable<UploadJob[]>;

  getJobStatusUpdate(idsAndStatus: IdAndStatus[]): Observable<{ jobUpdated: boolean, jobs: UploadJob[] }>;
}

export interface UploadJob {
  id: number;
  status: string;
  startTime: string;
  importEndTime: string;
  filename: string;
  path: string;
}

interface RainUploadJob extends UploadJob {
  stationName: string;
  calcEndTime: string;
}

interface EventUploadJob extends UploadJob {

}


@Injectable()
export class UploadJobsReaderService implements UploadJobsReader {

  intervalId: NodeJS.Timeout;
  subject: Subject<UploadJob[]> = new Subject<UploadJob[]>();
  activeStatus = ['COPIA', 'IMPORTACAO', 'CALCULO'];
  isActive = (job: UploadJob) => this.activeStatus.includes(job.status);
  idAndStatus = (job: UploadJob) => ({id: job.id, status: job.status});

  constructor(private config: UploadJobsReaderConfig, private http: HttpClient) {}

  async constantFetch() {

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    let jobs = await this.getAllJobs().toPromise();
    let activeJobsIdAndStatus = jobs.filter(this.isActive).map(this.idAndStatus);

    this.subject.next(jobs);

    if (activeJobsIdAndStatus.length == 0) {
      return;
    }

    this.intervalId = setInterval(async () => {

      // Se algum job ativo mudou, busca todos os jobs
      let statusUpdate = await this.getJobStatusUpdate(activeJobsIdAndStatus).toPromise();

      // O estado do job ativo não mudou desde a última consulta
      if (statusUpdate.jobUpdated == false) {
        return;
      }

      jobs = await this.getAllJobs().toPromise();

      // this.rainUploadJobs = statusUpdate.jobs;
      this.subject.next(jobs);

      // Se o job que estava ativo acabou, pode limpar o interval
      if (jobs.find(this.isActive) == null) {
        clearInterval(this.intervalId);
        return;
      }

    }, this.config.intervalInMs);
  }

  cancel(job: UploadJob) {
    return this.http.delete<{message: string}>(
      `${environment.serverBaseUrl}/${this.config.cancelUploadRoute}/${job.id}`
    );
  }

  getAllJobs(): Observable<UploadJob[]> {
    return this.http.get<UploadJob[]>(
      `${environment.serverBaseUrl}/${this.config.getUploadsRoute}`
    );
  }

  getJobStatusUpdate(idsAndStatus: IdAndStatus[]): Observable<{ jobUpdated: boolean; jobs: UploadJob[]; }> {
    return this.http.post<{ jobUpdated: boolean; jobs: UploadJob[]; }>(
      `${environment.serverBaseUrl}/${this.config.getStatusUpdateRoute}`,
      { jobs: idsAndStatus }
    );
  }
}

interface IdAndStatus {
  id: number;
  status: string;
}

interface UploadJobsReaderConfig {
  startUploadRoute: string;
  cancelUploadRoute: string;
  getUploadsRoute: string;
  getStatusUpdateRoute: string;
  intervalInMs: number;
}
